import React, { createContext, useContext, useState, useCallback } from 'react';

const ConfirmContext = createContext(null);

export const useConfirm = () => useContext(ConfirmContext);

export const ConfirmProvider = ({ children }) => {
  const [dialog, setDialog] = useState(null);
  // dialog: { message, subtext, confirmLabel, danger, resolve }

  const confirm = useCallback((message, { subtext = '', confirmLabel = 'אשר', danger = true } = {}) => {
    return new Promise((resolve) => {
      setDialog({ message, subtext, confirmLabel, danger, resolve });
    });
  }, []);

  const handleConfirm = () => { dialog?.resolve(true);  setDialog(null); };
  const handleCancel  = () => { dialog?.resolve(false); setDialog(null); };

  return (
    <ConfirmContext.Provider value={{ confirm }}>
      {children}

      {dialog && (
        <div
          className="fixed inset-0 z-[9998] flex items-end sm:items-center justify-center p-4 font-body"
          style={{ backgroundColor: 'rgba(0,0,0,0.45)', backdropFilter: 'blur(8px)' }}
          dir="rtl"
          onClick={handleCancel}
        >
          <div
            className="w-full max-w-sm bg-surface-container-lowest rounded-xl p-7 shadow-[0px_24px_80px_rgba(0,0,0,0.2)] animate-slide-in"
            onClick={e => e.stopPropagation()}
          >
            {/* Icon */}
            <div className={`w-14 h-14 mx-auto rounded-full flex items-center justify-center mb-5 ${dialog.danger ? 'bg-error/10' : 'bg-primary/10'}`}>
              <span
                className={`material-symbols-outlined text-3xl ${dialog.danger ? 'text-error' : 'text-primary'}`}
                style={{ fontVariationSettings: "'FILL' 1" }}
              >
                {dialog.danger ? 'delete_forever' : 'help'}
              </span>
            </div>

            {/* Text */}
            <h3 className="text-xl font-headline font-bold text-on-surface text-center mb-2">
              {dialog.message}
            </h3>
            {dialog.subtext && (
              <p className="text-sm text-on-surface-variant text-center leading-relaxed mb-6">
                {dialog.subtext}
              </p>
            )}
            {!dialog.subtext && <div className="mb-6" />}

            {/* Buttons */}
            <div className="flex flex-col gap-2.5">
              <button
                onClick={handleConfirm}
                className={`w-full py-3.5 rounded-full font-label font-bold text-white text-base transition-all active:scale-95 ${
                  dialog.danger
                    ? 'bg-error shadow-md shadow-error/20'
                    : 'bg-gradient-to-r from-primary to-primary-container shadow-md shadow-primary/20'
                }`}
              >
                {dialog.confirmLabel}
              </button>
              <button
                onClick={handleCancel}
                className="w-full py-3.5 rounded-full font-label font-semibold text-on-surface-variant text-base hover:bg-surface-container transition-colors"
              >
                ביטול
              </button>
            </div>
          </div>
        </div>
      )}
    </ConfirmContext.Provider>
  );
};
